export default {
  button: {
    addStaff: 'Add Staff',
    more: 'View More',
    cancel: 'Cancel',
    create: 'Add Project',
    delete: 'Delete',
    done: 'Done',
    removeStaff: 'Remove',
    reset: 'Reset',
    save: 'Save',
    view: 'View',
  },
  input: {
    label: {
      client: 'Client',
      name: 'Name',
      year: 'Year',
    },
    message: {
      noResult: 'No results found',
    },
    placeholder: {
      client: 'Search the project',
      name: 'The name of the project',
      year: 'The year which the project began',
    }
  },
  message: {
    error: {
      client: {
        content: 'Your request could not be completed. Please ensure you have the correct settings for your account.',
        title: 'Unprocessable Request!',
      },
      fields: {
        content: 'Check your fields then try again.',
        title: 'Oops!',
      },
      retrieve: {
        content: 'Unable to get the required information to display here.',
        title: 'Error retrieving information',
      },
      server: {
        content: 'A problem occurred while communicating with the server. Please try again later.',
        title: 'Something went wrong!',
      },
      unexpected: {
        content: 'An unexpected issue occurred. Please try again later.',
        title: 'Something went wrong!',
      },
    },
    info: {},
    success: {
      create: {
        content: 'The new client has been added successfully.',
        title: 'Client created!',
      },
      edit: {
        content: 'The client has been updated successfully.',
        title: 'Update successful!',
      },
    },
    warn: {
      empty: {
        content: 'Nothing here yet. Create a project by clicking the button above',
        title: 'Hmmmm!',
      },
    },
  },
  table: {
    header: {
      client: 'Client',
      year: 'Year',
    },
  },
  title: {
    create: 'Add Project',
    edit: 'Edit {{name}}',
    index: 'Projects',
  },
};